export default "__VITE_ASSET__CCaBbu4C__"